module.exports = __webpack_public_path__ + "img/account-manage.9147d17d.png";